import { z } from 'zod';

import {
  indexSearchSchema,
  listParams,
  type ListParams,
} from '@nucleus-commerce/admin-kit/index-table';

import { DEFAULT_STATUS_TAB, STATUS_TABS, type StatusTab } from './application-rules';

/**
 * URL search params of the applications list; mirrors GET /platform/v1/applications. The status
 * tab is one value (the endpoint accepts several); no status means the default tab.
 */
export const applicationListSearchSchema = indexSearchSchema([]).extend({
  status: z.enum(STATUS_TABS).optional().catch(undefined),
});

export type ApplicationListSearch = z.infer<typeof applicationListSearchSchema>;

export function statusTabOf(search: Pick<ApplicationListSearch, 'status'>): StatusTab {
  return search.status ?? DEFAULT_STATUS_TAB;
}

/** The list request for a validated search; the loader and the page build the same one. */
export function applicationListParams(search: ApplicationListSearch): ListParams {
  return { ...listParams(search), status: statusTabOf(search) };
}
